module.exports = __webpack_public_path__ + "img/blindaje-izquierda.8a7c387b.jpg";